// extracted by css-extract-rspack-plugin
export default {"Octicon":"use-milestone-editor-module__Octicon__YWaMU"};